import type { InventoryBySerialNumber } from '@ztechapps/common.contract'
import type { ModalProps } from '@ztechapps/webui.modal'
import { Modal } from '@ztechapps/webui.modal'
import { HorizontalStack } from '@ztechapps/webui.util'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import type { InventoryBySerialNumberCodeInputProps } from './inventoryBySerialNumberCodeInput'
import { InventoryBySerialNumberCodeInput } from './inventoryBySerialNumberCodeInput'
import { useState } from 'react'
import { InventoryBySerialNumberModalTrigger } from '../InventoryBySerialNumberModalTrigger'

type InventoryBySerialNumberCodeInputModalProps = Omit<InventoryBySerialNumberCodeInputProps, 'onChange'> & {
  trigger?: ModalProps['trigger']
  isBusy?: boolean
  children?: React.ReactNode
  onChange: (value: InventoryBySerialNumber[]) => Promise<void>
}

export function InventoryBySerialNumberCodeInputModal({
  trigger,
  onChange,
  value,
  maxQtySerialNumber,
  disabled,
  children,
  isBusy,
}: InventoryBySerialNumberCodeInputModalProps) {
  const [serialNumbers, setSerialNumbers] = useState<InventoryBySerialNumber[]>(value)

  const modalTrigger =
    trigger ||
    ((triggerProps) => (
      <InventoryBySerialNumberModalTrigger {...triggerProps} inventoryBySerialNumbers={value} disabled={disabled} />
    ))

  return (
    <Modal centered size="md" trigger={modalTrigger}>
      {({ toggleShowModal }) => {
        return (
          <>
            <Modal.DragHandle>Set Serial Number</Modal.DragHandle>
            <Modal.Body>
              <InventoryBySerialNumberCodeInput
                value={serialNumbers}
                onChange={setSerialNumbers}
                maxQtySerialNumber={maxQtySerialNumber}
              />

              {children}
            </Modal.Body>
            <Modal.Footer>
              <HorizontalStack className={'justify-content-end'}>
                <SaveCancelButtons
                  isBusy={isBusy}
                  disabled={(maxQtySerialNumber !== -1 && serialNumbers.length !== maxQtySerialNumber) || disabled}
                  onSave={async () => {
                    await onChange(serialNumbers)
                    toggleShowModal()
                  }}
                  onCancel={async () => {
                    //we just need to clear the data
                    await onChange(value)
                    setSerialNumbers(value)
                    toggleShowModal()
                  }}
                />
              </HorizontalStack>
            </Modal.Footer>
          </>
        )
      }}
    </Modal>
  )
}
